module.exports = __webpack_public_path__ + "static/media/stack-fill (1).f04bc7bb.svg";